<template>
    <div>
        <Language :add="add" v-model="form.lang" @change="handleLangChange"></Language>
        <el-form :model="form" :rules="rules" ref="form" label-width="100px">
            <el-form-item label="标题" prop="title">
                <el-input placeholder="请输入标题" style="width: 300px" v-model="form.title"></el-input>
            </el-form-item>
            <el-form-item label="副标题" prop="sub_title">
                <el-input placeholder="请输入副标题" style="width: 300px" v-model="form.sub_title"></el-input>
            </el-form-item>
            <el-form-item label="视频" prop="url">
                <Uploader type="video" v-model="form.url">{{ form.url ? "替换视频" : "添加视频" }}</Uploader>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" style="width: 120px" @click="handleSave">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import Language from "@/components/Language";
import Uploader from "@/components/Uploader";
import { detail, edit } from "@/api/content/home";
export default {
    components: {
        Language,
        Uploader,
    },
    data() {
        return {
            form: {
                lang: "zh",
                title: "",
                sub_title: "",
                url: "",
            },
            rules: {
                title: [{ required: true, message: "请输入标题" }],
                sub_title: [{ required: true, message: "请输入副标题" }],
                url: [{ required: true, message: "请上传视频" }],
            },
            add: true,
        };
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ lang: this.form.lang }).then(({ code, result, error }) => {
                if (code === 200) {
                    if (result) {
                        this.add = false;
                        this.form = { ...result, lang: this.form.lang };
                    } else {
                        this.add = true;
                        this.form = { lang: this.form.lang };
                    }
                    this.$nextTick(() => {
                        this.$refs.form.clearValidate();
                    });
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleLangChange() {
            this.getDetail();
        },
        handleSave() {
            this.$refs.form.validate((valid) => {
                if (!valid) return;
                const params = {
                    lang: this.form.lang,
                    title: this.form.title,
                    sub_title: this.form.sub_title,
                    url: this.form.url,
                };
                edit(params).then(({ code, error }) => {
                    if (code === 200) {
                        this.$message.success("保存成功");
                    } else {
                        this.$message.error(error.message);
                    }
                });
            });
        },
    },
};
</script>

<style></style>
